// extracted by mini-css-extract-plugin
export default {"Switcher":"OurReferences_Switcher__vsm9-"};